"use client";

import { UseFormRegisterReturn } from "react-hook-form";
import { variantsChildren } from "./form";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { useAppContext } from "../appContext";
import { m } from "framer-motion";
import Button from "../button";

type InputProps = {
  label: string;
  id: string;
  error?: string;
  register: UseFormRegisterReturn;
  type?: string;
};

const SuccessMessage = ({ closeButton }: { closeButton: boolean }) => {
  const { closeLightbox } = useAppContext();
  const t = useTranslations("form");

  return (
    <m.div
      variants={variantsChildren}
      key="success"
      className="flex flex-col items-center gap-4 max-w-md"
    >
      <Image
        src="/media/success.gif"
        alt="success"
        width={200}
        height={200}
        unoptimized
        className="w-64"
      />
      <h2 className="h4 uppercase text-center mt-8">{t("successTitle")}</h2>
      <div className="text-center">{t("successMessage")}</div>
      {closeButton && (
        <Button className="mt-4" onClick={() => closeLightbox()}>
          {t("close")}
        </Button>
      )}
    </m.div>
  );
};

export default SuccessMessage;
